import {Component, OnInit} from "@angular/core";
import {Title} from "@angular/platform-browser";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "app-root",
  template: `
    <router-outlet></router-outlet>
  `,
})

export class AppComponent implements OnInit {
  public constructor(private titleService: Title) {}

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  public ngOnInit(): void {
    this.setTitle("BPA");
  }
}
